import { LanguagesApiService } from '../../common/services/languages.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    status: REQUEST_STATUS.LOADING,
    defaultLanguage: '',
    formLanguage: '',
  },
  getters: {
    getForComboBox: state =>
      state.items.map(item => ({
        value: item.id,
        text: item.name,
      })),
    getAll: state => state.items,
    getIds: state => state.items.map(curr => curr.id),
    defaultLanguage: state => state.defaultLanguage,
    formLanguage: state => state.formLanguage,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_DEFAULT_LANGUAGE(state, data) {
      state.defaultLanguage = data;
    },
    SET_FORM_LANGUAGE(state, data) {
      state.formLanguage = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAll({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return LanguagesApiService.getAll()
        .then(response => {
          const languages = response.getItems();
          const defaultLanguage = languages.find(curr => curr.isDefault);

          commit('SET_ITEMS', languages);
          commit('SET_DEFAULT_LANGUAGE', defaultLanguage.id);
          commit('SET_FORM_LANGUAGE', defaultLanguage.id);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
